<template>
  <div class="mediate">
    <Row class="detail-header">
      <span>调解</span>
      <Row style="float:right;">
        <Button
          v-if="infoCtrl&&defaultData" type="primary"
          @click="edit()"
        >修改</Button>
      </Row>
    </Row>
    <Row class="case-content">
      <!-- 调解表单 -->
      <Row v-if="!infoCtrl&&isDetailLoad">
        <Form
          ref="formData" :model="formData"
          :rules="ruleValidate" :disabled="caseState=='TN'"
          :label-width="120" style="height:100%"
        >
          <FormItem label="选择节点" prop="nodeData">
            <RadioGroup v-model="formData.nodeData" @on-change="changeNode">
              <Radio
                v-for="(item,index) in nodeReduceData" :key="index"
                :label="item.nodeIndex"
              >{{ item.name }}</Radio>
            </RadioGroup>

          </FormItem>
          <FormItem
            v-if="!isEdit || isEdit && defaultData.auditState!='E'" label="调解对象"
            prop="selectIdArr"
          >
            <!-- <Select v-model="formData.selectIdArr" multiple placeholder="请选择对方当事人" label-in-value @on-change="getSelectValue">
                            <Option v-for="item in litigantIdArr" :value="item.id" :key="item.id" :label="item.name" :tag="item.name">
                                <div class="litigant-info textover">名称：{{item.name}} --- 法人：{{item.legalRepresentative}}</div>
                                <div>地址：{{item.provinceName}}{{item.cityName}}{{item.areaName}}{{item.address}}</div>
                            </Option>
                        </Select> -->
            <Select
              v-model="formData.selectIdArr" multiple
              placeholder="请选择对方当事人" label-in-value
              @on-change="getSelectValue"
            >
              <Option
                v-for="item in litigantIdArr" :key="item.id"
                :value="item.id"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem
            v-if="isEdit && defaultData.auditState=='E'" label="调解对象"
            prop="selectIdArr"
          >
            <Input :value="defaultData.litigantNames" disabled />
          </FormItem>
          <FormItem label="调解内容" prop="content">
            <Input
              v-model.trim="formData.content" type="textarea"
              :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写调解内容"
            />
          </FormItem>
          <FormItem
            v-if="!isEdit || isEdit && defaultData.auditState!='E'" label="调解金额"
            prop="fee"
          >
            <my-input
              append-text="￥"
              :default-data="formData.fee"
              :to-fixed="2"
              @getValue="getInputValue($event,'fee')"
            />
          </FormItem>
          <FormItem
            v-if="isEdit && defaultData.auditState=='E'" label="调解金额"
            prop="fee"
          >
            <Input :value="'￥' + defaultData.fee" disabled />
          </FormItem>

          <FormItem
            label="调解结果"
            prop="succeed"
            :rules="{required: true,type:'number',message: '调解结果不能为空', trigger: 'blur'}"
          >
            <RadioGroup v-model="formData.succeed">
              <Radio :label="1">成功</Radio>
              <Radio :label="0">失败</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem
            label="调解协议"
            prop="attachments"
            :rules="formData.succeed===1?{required: true, type:'array',message: '调解协议不能为空', trigger: 'blur'}:{ type:'array'}"
          >
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{}"
              @getFileList="getAttachmentList($event,'attachments')"
            />
          </FormItem>
          <Row class="detail-btn-box">
            <Button
              type="primary" style="margin-right:10px;"
              :disabled="isSubmit" @click="submitNew"
            >保存</Button>
            <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
          </Row>
        </Form>

      </Row>

      <!-- 调解详情 -->
      <Row v-if="infoCtrl&&isDetailLoad" class="detail-content">
        <Row><Col span="5" class="left-label">选择节点：</Col><Col span="16" class="right-content">{{ defaultData.prevNodeName || "" }}</Col></Row>
        <Row><Col span="5" class="left-label">调解对象：</Col><Col span="16" class="right-content">{{ defaultData.litigantNames || "" }}</Col></Row>
        <Row><Col span="5" class="left-label">调解内容：</Col><Col span="16" class="right-content">{{ defaultData.content || "" }}</Col></Row>
        <Row><Col span="5" class="left-label">调解金额：</Col><Col span="16" class="right-content">{{ common.formateNumber(defaultData.fee || "") }}</Col></Row>
        <Row v-if="defaultData.auditState">
          <Col span="5" class="left-label">审核结果：</Col>
          <Col span="16" class="right-content">
            <Tag style="border-radius:11px;" :color="getTagColor(defaultData.auditState)">{{ defaultData.auditStateName }}</Tag>
          </Col>
        </Row>
        <Row><Col span="5" class="left-label">审核备注：</Col><Col span="16" class="right-content">{{ defaultData.auditRemark }}</Col></Row>

        <!-- <Row style="text-align:right;">
          <Button v-if="editState" type="primary" @click="infoCtrl=false">修改</Button>
        </Row> -->
        <Row class="detail-content">
          <Row>
            <Col span="5" class="left-label">调解结果：</Col>
            <Col span="16" class="right-content">{{ getSucceed(mediate.succeed) }}</Col>
          </Row>
          <Row>
            <Col span="5" class="left-label">调解协议：</Col>
            <Col span="16" class="right-content">
              <file-upload
                :default-list="mediate.attachments || []"
                :upload-config="{readOnly:true}"
              />
            </Col>
          </Row>
        </Row>

      </Row>
    </Row>

    <!-- <mediate-result :edit-state="editState" :edit-id="editId" :process-id="processId" :case-id="caseId" :node-id="nodeId" @getDetail="getDetail" @reloadList="reloadList" /> -->
    <!-- <mediate-result v-if="defaultData.auditState=='E'" @getDetail="getDetail" :editState="editState" :defaultData="defaultData" @reloadList="reloadList" :editId="editId" :processId="processId" :caseId="caseId" :nodeId="nodeId"></mediate-result> -->
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
export default {
  props: ['processId', 'caseId', 'nodeId', 'editState', 'caseState', 'nodeReduceId', 'tabActive', 'prevProcessId', 'isButtonClick'],
  data () {
    const overMillion = (rule, value, callback) => {
      if (Number(value) > 100000000) {
        return callback(new Error('金额不能超过一亿'))
      }
      callback()
    }
    return {
      styles: styles,
      isEdit: false,
      infoCtrl: false,
      isDetailLoad: false,
      isSubmit: false,
      defaultList: [],
      litigantIdArr: [],
      defaultData: '',
      formData: {
        selectIdArr: [],
        litigantIds: '',
        content: '',
        fee: '',
        litigantNames: '',
        succeed: '',
        attachments: [],
        remark: '',
        resultInfoVOId: '',
        nodeData: ''
      },
      nodeReduceData: [],
      ruleValidate: {
        selectIdArr: [{ required: true, type: 'array', message: '调解对象不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '调解内容不能为空', trigger: 'blur' }, { max: 512, message: '不能超过512个字符', trigger: 'blur' }],
        fee: [{ required: true, message: '调解金额不能为空', trigger: 'blur' }, { validator: overMillion, trigger: 'blur' }],
        nodeData: [{ required: true, type: 'number', message: '节点不能为空', trigger: 'blur' }]
      },
      editId: '',
      mediate: {
        succeed: '',
        attachments: []
      }
    }
  },
  watch: {
    isButtonClick(nV, oV) {
      console.log(nV, oV)
      if (nV) {
        this.defaultData = ''
        this.infoCtrl = false
        this.defaultList = []
        Object.keys(this.formData).forEach(key => {
          if (key !== 'selectIdArr' && key !== 'attachments') {
            this.$set(this.formData, key, '')
          } else {
            this.$set(this.formData, key, [])
          }
        })
      } else {
        this.getDetail(true)
      }
    }
  },
  created() {
  },
  beforeMount() {
    this.getNodeData()
    this.getLitigantIdArr()
    this.isButtonClick ? this.isDetailLoad = true : this.getDetail(true)
  },
  mounted() {},
  updated() {},
  methods: {
    edit() {
      this.infoCtrl = false
      this.isEdit = true
      this.getDetail(false)
    },
    getSucceed(data) {
      if (data == null) {
        return ''
      } else if (data == 1) {
        return '成功'
      } else {
        return '失败'
      }
    },
    // 获取节点
    getNodeData() {
      const url = '/business/case/process/optional?optional=2&caseId=' + this.caseId
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.nodeReduceData = res.data
        }
      })
    },
    // 选择节点
    changeNode(data) {
      this.formData.nodeData = data
    },
    // 获取调解详情
    getDetail(flag) {
      const url = `/business/case/mediation?processId=${this.processId}&type=ME`
      this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          this.defaultData = res.data
          this.editId = res.data.id
          if (res.data.result && res.data.result !== null) {
            this.formData.resultInfoVOId = res.data.result.id
            this.formData.succeed = res.data.result.succeed ? 1 : 0
            this.mediate.succeed = res.data.result.succeed
            this.mediate.attachments = res.data.result.attachments
          } else if (res.data.result == null) {
            this.mediate.succeed = null
            this.mediate.attachments = []
          }
          this.infoCtrl = flag
          this.giveDefaultData()
        } else {
          this.isDetailLoad = true
        }
      })
    },
    reloadList() {
      this.$emit('reloadProcess')
    },
    giveDefaultData() {
      const arr = this.defaultData.litigantIds ? this.defaultData.litigantIds.split(',') : []
      this.formData.selectIdArr = []
      arr.forEach((item, index) => {
        this.formData.selectIdArr.push(Number(item))
      })
      this.formData.litigantIds = this.defaultData.litigantIds
      this.formData.content = this.defaultData.content
      this.formData.fee = this.defaultData.fee + ''
      this.formData.litigantNames = this.defaultData.litigantNames
      this.formData.nodeData = this.defaultData.prevNodeIndex
      if (this.defaultData.result) {
        const tempAttachments = this.defaultData.result.attachments || []
        this.defaultList = tempAttachments
        this.formData.attachments = tempAttachments
      }
      this.isDetailLoad = true
    },
    getAttachmentList(daraArr) {
      this.formData.attachments = []
      daraArr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData.attachments.push(obj)
      })
    },
    getInputValue(value, key) {
      this.formData[key] = value
    },
    getSelectValue(arr) {
      this.formData.litigantIds = ''
      this.formData.litigantNames = ''
      arr.forEach((item, index) => {
        this.formData.litigantIds += index == 0 ? item.value : `,${item.value}`
        this.formData.litigantNames += index == 0 ? item.label : `,${item.label}`
      })
    },
    // 获取对方当事人
    getLitigantIdArr() {
      const url = `/business/litigants/${this.caseId}/mediation`
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.litigantIdArr = res.data || []
        }
      })
    },
    getTagColor(state) {
      const obj = {
        'P': styles.warningColor,
        'E': styles.successColor,
        'R': styles.errorColor
      }
      return obj[state]
    },
    submitNew() {
      const url = '/business/case/mediation/mini'

      const ajaxData = {
        mediationInfoVO: {
          selectIdArr: this.formData.selectIdArr, // 调解对象
          litigantIds: this.formData.litigantIds,
          litigantNames: this.formData.litigantNames,
          fee: this.formData.fee, // 调解金额
          caseId: this.caseId,
          prevNodeIndex: this.formData.nodeData,
          content: this.formData.content,
          id: this.defaultData.id
        },
        resultInfoVO: {
          attachments: this.formData.attachments, // 调解协议
          caseId: this.caseId,
          prevNodeIndex: this.formData.nodeData,
          id: this.formData.resultInfoVOId,
          succeed: this.formData.succeed
        }
      }
      if (this.isEdit) {
        // 编辑
        // url += `/${this.defaultData.id}`
        ajaxData.auditState = 'P'

        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.getDetail(true)
                this.$emit('reloadProcess')
                this.$Message.success('操作成功')
                this.isEdit = false
              } else {
                this.$Message.error(res.message)
              }
              this.isSubmit = false
            })
          }
        })
      } else {
        // 新增
        if (this.formData.nodeData && this.formData.nodeData !== '') {
          this.nodeReduceData.forEach(item => {
            if (item.nodeIndex == this.formData.nodeData) {
              ajaxData.mediationInfoVO.processId = item.processId
            }
          })
        }

        ajaxData.mediationInfoVO.nodeId = this.nodeId
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.$emit('reloadProcess')
                this.$Message.success('操作成功')
              } else {
                this.$Message.error(res.message)
              }
              this.isSubmit = false
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../caseCommon.scss';
.litigant-info{
    width:100%;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/listOptions/mediate.vue